import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import FundMappingsService, {
  FundMapping,
} from 'donor-elf-web/services/fund-mappings-service';

export interface FundMappingsEditRouteModel {
  fundMapping?: FundMapping;
}

export default class FundMappingsEditRoute extends Route {
  @service declare fundMappingsService: FundMappingsService;
  @service declare fundsService: any;
  @service declare navbarSettings: any;
  @service declare store: Store;

  model(params: { fundMappingId: string }): FundMappingsEditRouteModel {
    this.navbarSettings.title = 'Edit Fund Mapping';
    if (params.fundMappingId === 'add') {
      return {
        fundMapping: new FundMapping({
          fund: this.store.createRecord('admin/fund', { active: true }),
        }),
      };
    } else {
      return {
        fundMapping: this.fundMappingsService.fundMappings.find(
          (x) => x.fund.id === params.fundMappingId,
        ),
      };
    }
  }
}
